module.exports = __webpack_public_path__ + "static/media/img3-1.79520f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/soilcheck/rhumedad/img3-1.png
// module id = 2187
// module chunks = 3